// due_date é um instante real, no fuso de quem usa. A API devolve epoch em
// segundos e recebe ISO 8601. Meia-noite local significa "sem horário".
// Toda tela de tarefas deve passar por aqui para ler e gravar a data, senão
// a mesma tarefa aparece com horários diferentes em cada lugar.

const pad = value => String(value).padStart(2, '0');

export const browserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export function toLocalDateString(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function dueDateKey(epochSeconds) {
  return toLocalDateString(new Date(epochSeconds * 1000));
}

export function hasDueTime(epochSeconds) {
  const d = new Date(epochSeconds * 1000);
  return d.getHours() !== 0 || d.getMinutes() !== 0;
}

export function dueTimeLabel(epochSeconds) {
  const d = new Date(epochSeconds * 1000);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function dueMinutesSinceMidnight(epochSeconds) {
  const d = new Date(epochSeconds * 1000);
  return d.getHours() * 60 + d.getMinutes();
}

// { due_date: 'YYYY-MM-DD', due_time: 'HH:MM' | null } no formato dos pickers
export function splitDue(epochSeconds) {
  if (!epochSeconds) return { due_date: null, due_time: null };
  return {
    due_date: dueDateKey(epochSeconds),
    due_time: hasDueTime(epochSeconds) ? dueTimeLabel(epochSeconds) : null,
  };
}

// 'YYYY-MM-DD' (+ 'HH:MM') no horário local -> ISO em UTC
export function buildDueIso(date, time = null) {
  if (!date) return null;
  const [y, mo, d] = date.split('-').map(Number);
  const [h, m] = time ? time.split(':').map(Number) : [0, 0];
  return new Date(y, mo - 1, d, h, m, 0, 0).toISOString();
}

// fim da recorrência: o picker trabalha com 'YYYY-MM-DD' e a API grava o fim
// do dia local, para a última ocorrência daquele dia ainda ser gerada
export function recurrenceEndsToPicker(epochSeconds) {
  return epochSeconds ? dueDateKey(epochSeconds) : null;
}

export function recurrenceEndsToIso(date) {
  return date ? buildDueIso(date, '23:59') : null;
}
